import { Alert, Box, Button } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import Text from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  onClose: () => void
  onSubmit: () => void
  employee: Employee
  field: Field
  running: boolean
}

const ConfirmPasswordModal = ({ onClose, onSubmit, employee, field, running }: Props) => {
  const {
    access: { id: userId },
  } = useCurrentSession()
  const getDescriptionCopy = () => {
    const employeeIsOwn = employee.attributes.access_id === userId

    return employeeIsOwn
      ? i18n.t('common.confirm_password_description')
      : i18n.t('common.confirm_password_description_other')
  }

  return (
    <Modal
      illustration="password-lock"
      title={i18n.t('common.confirm_password')}
      description={getDescriptionCopy()}
      onClose={onClose}
      footer={
        <Button onClick={onSubmit} disabled={!field.isDirty || running}>
          {i18n.t('common.submit')}
        </Button>
      }
    >
      <Box gap="s16">
        <Alert color="warning">{i18n.t('common.confirm_email_change.alert')}</Alert>
        <Text type="password" field={field} label={i18n.t('common.password')} />
      </Box>
    </Modal>
  )
}

export default observer(ConfirmPasswordModal)
